import { Box, Divider, Stack } from '@mui/material';
import { useState } from 'react';
import { AppCopyExportButton } from '../../shared/content/AppCopyExportButton';
import { borderRadius } from '../../theme/theme';
import { isRecorderUiEnabled } from '../recording/recorderBuildPolicy';
import RecorderControls from './RecorderControls';

type DeveloperDockProps = {
  readonly enabled?: boolean;
};

export function DeveloperDock({ enabled = isRecorderUiEnabled() }: DeveloperDockProps) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  if (!enabled) return null;

  return (
    <Box
      data-testid="recorder-dock"
      data-copy-export-ignore="true"
      sx={{
        position: 'fixed',
        left: 8,
        bottom: { xs: isCollapsed ? 8 : 56, sm: 8 },
        zIndex: (theme) => theme.zIndex.snackbar + 1,
        maxWidth: 'calc(100vw - 16px)',
        p: 0.75,
        borderRadius: `${borderRadius.md}px`,
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: 3,
      }}
    >
      <Stack direction="row" spacing={0.75} alignItems="center">
        <RecorderControls isCollapsed={isCollapsed} onCollapseChange={setIsCollapsed} />
        {!isCollapsed && (
          <>
            <Divider orientation="vertical" flexItem />
            <AppCopyExportButton />
          </>
        )}
      </Stack>
    </Box>
  );
}
